module.exports = __webpack_public_path__ + "media/images/base-icon-cfc30d376501073a348d232964f0cd8e.svg";